import { RowProps, RowSourse } from 'features/schools/table/models';

export const transformRowProps = (
  {
    municipality_name,
    school_location,
    school_name,
    school_count,
    active_student_count,
    active_teacher_count,
    reg_student_count,
    reg_teacher_count,
    student_count,
    school_id,
    involvement_percent,
  }: RowSourse,
  isRegion: boolean,
): RowProps => ({
  location: isRegion ? municipality_name! : school_location!,
  school: school_name,
  schoolsCount: school_count,
  activeStudents: active_student_count,
  activeTeachers: active_teacher_count,
  registeredStudents: reg_student_count,
  registeredTeachers: reg_teacher_count,
  studentCount: student_count || null,
  schoolId: school_id,
  involvementPercent: involvement_percent ?? 0,
  involvementLowered: !!involvement_percent && involvement_percent < -30,
});
